
import React, { useEffect, useState } from "react";
import { app, getAuth } from "./firebaseConfig";
import Loading from '../components/Loading'

const Auth = React.createContext({ name: '', user: null });

const AuthContext = ({ children }) => {
    const [user, setUsuario] = useState(null);
    const [showChild, setShowChild] = useState(false);

    useEffect(() => {
      const au = getAuth(app);
      au.onAuthStateChanged(async (user) =>{
          const cus = au.currentUser;
          const hayUser = cus != null
          if(hayUser) {
              setUsuario(user);
          } else {
              setUsuario(null)
          }
          setShowChild(true);
      });
    }, []);

    if (!showChild) {
        return <Loading/>;
    } else {
        return (
            <Auth.Provider value={{ user }} key={+new Date()}>
                {children}
            </Auth.Provider>
        );
    }    
};
    function useFirebaseAuth() {
      const context = React.useContext(Auth);
      if (context === undefined) {
        throw new Error(
          "useFirebaseAuth must be used within a FirebaseAuthProvider"
          );
        }
        return context.user;
      }
      
  export { Auth, AuthContext, useFirebaseAuth };